import { Box, Text, Link } from '@chakra-ui/react';

import UlfLayoutContainer from './UlfLayoutContainer';
import { Trans } from 'react-i18next';

const Disclaimer = () => {
  return (
    <UlfLayoutContainer>
      <Box layerStyle="uflContainerMd" my={4}>
        <Text textAlign="center">
          <Trans>
            By clicking "NEXT" or "SAVE", I give TWO MEN AND A TRUCK and its{' '}
            franchisees, consent to record, and use my phone number and other{' '}
            information provided to contact me about my request via phone and/or{' '}
            email, (including via automated technology). I may refer to the{' '}
            <Link
              variant="unstyled"
              href="https://www.servicemaster.com/privacy-policy/"
              target="_blank"
            >
              Privacy Policy
            </Link>{' '}
            for my other rights.
          </Trans>
          <Trans></Trans>
        </Text>
      </Box>
    </UlfLayoutContainer>
  );
};

export default Disclaimer;
